import type { MaybeRef } from "vue"
import type { IReminder, IReminderRequest } from "@/types"
import { useMutation } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"

export async function createReminder(reminder: IReminder, eventVaultId?: number) {
  if (!eventVaultId) {
    throw new Error(
      "Missing `eventVaultId` when attempting to create a reminder. Please ensure `eventVaultId` is provided.",
    )
  }
  const reminderRequest: IReminderRequest = {
    Name: reminder.name,
    Email: reminder.email,
    RemindMeIn: reminder.when,
  }

  const response = await axios.post(`api/guest/${eventVaultId}/remindme`, reminderRequest)

  return response.data.Message
}

const CREATE_REMINDER_KEY = "createReminder"

export function useCreateReminder(eventVaultId: MaybeRef<number>) {
  return useMutation({
    mutationKey: [CREATE_REMINDER_KEY, eventVaultId],
    mutationFn: (reminder: IReminder) => createReminder(reminder, toValue(eventVaultId)),
  })
}
